var AngularVelocityUnit_1;
import { __decorate } from "tslib";
import { SerializableObject } from '../../data/decorators';
import { DerivedUnit } from './DerivedUnit';
import { AngleUnit } from './AngleUnit';
import { TimeUnit } from './TimeUnit';
/**
 * @category Unit
 */
let AngularVelocityUnit = AngularVelocityUnit_1 = class AngularVelocityUnit extends DerivedUnit {};
AngularVelocityUnit.RADIAN_PER_SECOND = new AngularVelocityUnit_1('radian per second', {
  baseName: 'angularvelocity',
  aliases: ['rad/s', 'radians per second']
}).addUnit(AngleUnit.RADIAN, 1).addUnit(TimeUnit.SECOND, -1);
AngularVelocityUnit.DEGREE_PER_SECOND = AngularVelocityUnit_1.RADIAN_PER_SECOND.swap([AngleUnit.DEGREE], {
  baseName: 'angularvelocity',
  name: 'degree per second',
  aliases: ['deg/s', 'degrees per second']
});
AngularVelocityUnit.RADIAN_PER_MINUTE = AngularVelocityUnit_1.RADIAN_PER_SECOND.swap([TimeUnit.MINUTE], {
  baseName: 'angularvelocity',
  name: 'radian per minute',
  aliases: ['rad/min', 'radian per minute']
});
AngularVelocityUnit.DEGREE_PER_MINUTE = AngularVelocityUnit_1.RADIAN_PER_SECOND.swap([AngleUnit.DEGREE, TimeUnit.MINUTE], {
  baseName: 'angularvelocity',
  name: 'degree per minute',
  aliases: ['deg/min', 'degrees per minute']
});
AngularVelocityUnit = AngularVelocityUnit_1 = __decorate([SerializableObject()], AngularVelocityUnit);
export { AngularVelocityUnit };